import { useState } from "react"
import BaseAppContainer from "../base--app-container/BaseAppContainer"
import LeftPanelMenu from "../left-panel-menu/LeftPanelMenu"
import Styles from "./AppStore.module.scss"
import AppMainScreen from "./app-main-screen/AppMainScreen"
import { APP_KEY_IDS } from "../../constants/constants"
import Loader from "../loader/Loader"

interface MyAppsProps{
    apps:any
}


const AppStore = ({apps}:MyAppsProps) => {

    const [activeOption, setActiveOption] = useState<any>("");
    const [appDetails,setAppDetails]=useState<any>({})

    const onSuccessfulSubmission=(app:any)=>{
        setAppDetails(app)
    }

    return (
        <BaseAppContainer loadFromX={-150} appId={APP_KEY_IDS.APP_STORE} width={800} height={600} title={""} 
        SideBar={
            <div className={Styles.left_container}>
                <LeftPanelMenu menuContent={Object.values(apps)} activeValue={activeOption} handleOptionClick={setActiveOption} onSuccessfulSubmission={onSuccessfulSubmission} />
            </div>
        } 
        MainScreen={
        <div className={Styles.container}>
           {
                appDetails.id ?  
                <AppMainScreen 
                    title={appDetails.label} 
                    description={appDetails.description}
                    icon={appDetails.icon}
                    type={appDetails.type}
                    screenshots={ appDetails.images ? Object.values(appDetails.images) : []
                    }
                />
                : <div className={Styles.placeholder}>No app selected</div>
           }
        </div>
        } 
        />
    )
}

export default AppStore
